module.exports = __webpack_public_path__ + "img/24.c03b5844.jpg";